import React, {Component} from 'react';
import {Loading} from '../../components/loading';
import {withRouter} from 'react-router-dom';

class HomeIndex extends Component {
  componentDidMount() {
    this.props.history.push('/business');
  }

  render() {
    return (
      <Loading>
        <div>
          Home
        </div>
      </Loading>
    );
  }
}

export default withRouter(HomeIndex);